import { ProjectConfigType } from '~/projects/types';

import { JustdoneBigLogo, JustdoneLogo } from './branding/JustdoneBrandLogo';

export const PROJECT_NAME = 'JustDone';

const config: ProjectConfigType = {
  name: PROJECT_NAME,
  getLogo: () => JustdoneLogo,
  getBigLogo: () => JustdoneBigLogo,
  getSendIcon: () => {
    const { ReactComponent } = require('./assets/send.svg');
    return ReactComponent;
  },
  supportEmail: 'support@justdone.ai',
  isExtensionAvailable: true,
};

export default config;
